import { render, staticRenderFns } from "./ComplianceReviewFilter.vue?vue&type=template&id=874edace&scoped=true"
import script from "./ComplianceReviewFilter.vue?vue&type=script&lang=js"
export * from "./ComplianceReviewFilter.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReviewFilter.vue?vue&type=style&index=0&id=874edace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874edace",
  null
  
)

export default component.exports